const RTF = new Intl.RelativeTimeFormat('de', { numeric: 'auto' });

/** Schwellen in Sekunden: ab dieser Dauer zählt die Einheit */
const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['minute', 60],
  ['hour', 3600],
  ['day', 86_400],
  ['week', 604_800],
  ['month', 2_629_800],
  ['year', 31_557_600],
];

/** Zeitpunkt relativ zu jetzt, auf Deutsch: „gerade eben“, „vor 5 Minuten“, „gestern“, „letzte Woche“, „vor 2 Jahren“. */
export function relativeTime(iso: string, now: number = Date.now()): string {
  const seconds = (Date.parse(iso) - now) / 1000;
  const abs = Math.abs(seconds);
  if (!Number.isFinite(abs) || abs < 60) return 'gerade eben';
  let [unit, size] = UNITS[0]!;
  for (const [u, s] of UNITS) if (abs >= s) [unit, size] = [u, s];
  return RTF.format(Math.round(seconds / size), unit);
}
